import { useObservable } from 'react-use'
import { BehaviorSubject } from 'rxjs'
import type { ArtworkDetailFragment } from 'src/services/apollo/generated/graphql'

const $personalPageActiveArtwork = new BehaviorSubject<
  ArtworkDetailFragment | undefined
>(undefined)

export const setPersonalPageActiveArtwork = (
  artwork?: ArtworkDetailFragment,
) => {
  $personalPageActiveArtwork.next(artwork)
}

export const usePersonalPageActiveArtwork = () => {
  const value = useObservable($personalPageActiveArtwork)
  return [value, setPersonalPageActiveArtwork] as const
}
